module.exports = __webpack_public_path__ + "img/shield_x_icon.eb0c405a.svg";